export const CurrencyEnum = {
  BRL: 1,
  USD: 2,
  GBP: 3,
  EUR: 4,
};
